module.exports = __webpack_public_path__ + "img/content-1.8fcc3730.png";